/**
 * `src/core/` public barrel.
 *
 * Composition primitives consumed by codegen-emitted public hooks:
 *   - `createHook(spec, realtime?)` — T15001 composition factory.
 *   - `useRealtimeQuery(opts)`      — T2002 wrapper around `useQuery`.
 *   - `RegistryContext`             — React context for the SubjectRegistry.
 */

// AUTO-GENERATED subfolder re-exports
export * from './boot/index.js';
// Experimental — exposed for consumers integrating list-level leaf hooks
// (`use<Entity>sField`) with external virtualized lists (RN FlashList,
// react-window, etc.) where `<Items>`' built-in iteration doesn't fit.
// Wrap each row in `<ListContext.Provider value={{queryKey, rowKey}}>`
// so the leaf hooks find their cache target the same way `<Items>` would.
// Codegen list-hook specs expose `queryKey` via `spec.entityKeys[kind](args)`.
export {
  ListContext,
  type ListContextValue,
} from './context/ListContext.js';
export { RegistryContext } from './context/RegistryContext.js';
export { createHook } from './factories/createHook.js';
export * from './hooks/index.js';
export {
  type RealtimeConnectivityHandle,
  type RealtimeQueryOptionsResolved,
  type RealtimeQueryResult,
  type RealtimeQuerySpec,
  realtimeQueryOptions,
  type UseRealtimeQueryOpts,
  useRealtimeQuery,
} from './hooks/useRealtimeQuery.js';
